/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toUpperCase(string: string) {
  return string.toUpperCase()
}

export default toUpperCase
